import { createContext } from 'react';
import { useStore } from 'react-redux'
const io = require("socket.io-client");
export const WebSocketContext = createContext({});

const WebSocket = ({ children }) => {
    const store = useStore().getState()
    const {
        auth: { user }
    } = store
    let host = window.location.host;
    let socket_connection_url;
    let protocol = window.location.protocol
    if (host.includes('localhost')) {
        socket_connection_url = 'http://localhost:3001';
    } else {
        socket_connection_url = `${protocol}//${host}`
    }
    const socketIo = io.connect(socket_connection_url, {
        maxHttpBufferSize: 1e6, // Increase buffer size if needed
        transports: ['websocket']
    });
    socketIo.on("connect", connectUser);
    socketIo.on("disconnect", (reason) => {
        var userId = user?.id // Retrieve userId
        if (!userId) return;
        socketIo.emit('userDisconnected', userId);
        io.connect(socket_connection_url, {
            maxHttpBufferSize: 1e6, // Increase buffer size if needed
            transports: ['websocket']
        });
    });

    socketIo.on("connect_error", (err) => { console.log(`connect_error due to ${err.message}`); });

    function connectUser() {  // Called whenever a user signs in
        var userId = user?.id  // Retrieve userId
        if (!userId) return;
        socketIo.emit('userConnected', userId);
    }
    return (
        <WebSocketContext.Provider value={{ socketIo }}>
            {children}
        </WebSocketContext.Provider>
    );
};

export default WebSocket;
